import { Component, Prop, Vue } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

import SwitchPortal from '@/components/edit/SwitchPortal/index.vue';

library.add(faAngleDown);

interface Item {
	label: string;
}

@Component({
	components: {
		SwitchPortal
	},
})
export default class RowEdit extends Vue {
	@Prop() data!: Item
	@Prop() readonly title
	@Prop({ default: false }) readonly error
}
